import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/global.css'
import { Hybrid } from '@/assets/js/Hybrid.js'
import { i18n } from "@/i18n/index.js";
const app = createApp(App)

// Hybrid 전역 인스턴스 생성 및 초기화
const hybrid = new Hybrid()

// 전역 속성으로 등록
app.config.globalProperties.$hybrid = hybrid

// 앱 마운트
app.use(store).use(router).use(i18n).mount('#app');


// Hybrid 전역 초기화
if (typeof window !== 'undefined') {
  window.$hybrid = hybrid
  
  // WebView2 사용 가능 시 리스너 등록
  if (hybrid.isWebViewAvailable()) {
    hybrid.listenToWebView()
    console.log('✅ 전역 Hybrid 초기화 완료 - WebView2 사용 가능')
  } else {
    console.log('ℹ️ 전역 Hybrid 초기화 완료 - 브라우저 모드')
  }
}
